import React,{Component} from 'react';
import PbAjax from '../../lib/pbajax';
import Cache from 'c-cache';
import publicpb from '../../base/public.pb';
import hostlistpb from './followlist.pb';
import lang from '../../lang';
import Item from './host-item';
import Follow from "../../component/follow";
import Loading from '../../component/loading';
import PreventParentScroll  from '../../lib/scroll/prevent-scroll';
import {Link} from "react-router";

let cache = new Cache({
    prefix: 'pcuplive'
});

class List extends Component {
    static defaultProps = {
        threshold: 100,
        keyword: ''
    }
    constructor(props) {
        super(props);

        this.state = {
            //keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: true,
            isEnd: false
        };

        this.page = 1;
        this.pageSize = 6;
        this.pbajax = new PbAjax();

        this.fetching = false; // 加载状态加锁
        this.first = true; // 第一页
        this.dataOver = false // 数据最后一页
    }

    componentWillMount(){
        this.loadData();

    }

    // componentWillReceiveProps(props) {

    //     this.fetching = false; // 加载状态加锁
    //     this.first = true; // 第一页
    //     this.dataOver = false // 数据最后一页
    //     this.page = 1

    //     this.setState({
    //         list: [],
    //         isLoading: false,
    //         isEmpty: false,
    //         isEnd: false,
    //         //keyword: props.keyword
    //     }, ()=>{
    //         this.loadData();
    //     });
        
    // }

    componentWillUnmount() {
        this.pbajax.cancel(); 
    }

    loadData() {
        this.loadDataByUserName();
    }

    loadDataByUserName(){
        if(this.fetching){
            return ;
        }
        this.fetching = true;
        let self = this;
        let defer = $.Deferred();
        let { Request, Response} = hostlistpb.Feed.FollowList;
        let businessData = new Request({
            page: this.page,
            pageSize: this.pageSize
        });

        this.pbajax.do(
            {
                service: 'service',
                api: '/feed/follow/list',
                header: {
                    lang: UP.Global.siteLanguage,
                    userToken: UP.Global.getUserToken()
                }
            },
            businessData,
            (res)=>{

                this.fetching = false;
                let dataWrap = publicpb.Result.decode(res);

                if (dataWrap.code == 1) {

                    let dataAll, data = [];

                    if (dataWrap.data.value ) {
                        dataAll = Response.decode(dataWrap.data.value);
                        data = dataAll.infos;
                    }

                    let list  = this.state.list;
                    let newState = {
                        list: [...list, ...data]
                    };

                    newState.isLoading = false;

                    if (data.length < this.pageSize) {
                        // 数据加载完
                        this.dataOver = true;
                        

                        if (this.first) {
                            if (data.length == 0) {
                                newState.isEmpty = true;
                            }
                        } else {
                            newState.isEnd = true;
                        }
                    }

                    if (this.first) {
                        // 第一页
                        this.first = false;
                    }
                    
                    newState = Object.assign({}, this.state, newState);

                    this.setState({...newState});
                    
                }

               
            },
             () => {
                this.fetching = false;
             }

        );
      
        this.page = this.page + 1;
    }



    onClick() {
        $.channel.emit('hideSearchResult');
    }

    render() {
        let list = this.state.list;
        let $list = [];
        let showList = ['username','gender', 'grade', 'roomTitle'];
        
        
        list.slice(0,5).forEach((obj, idx)=>{
            $list.push(<Item key={obj.uid} item={obj} onClick={this.onClick} showList={showList}></Item>);
        });

        if (list.length > 5) {
            $list[$list.length] = (
                <div className="more" key={$list.length + 1}>
                    <Link to='/allhostlist/follow'>{lang.template('查看更多')}</Link>
                </div>
            );
        }
        
        return (
            <div ref="content">
                <PreventParentScroll/>
                <ul>
                   {$list} 
                </ul>
                { this.state.isLoading ? <Loading/> : null }
                { this.state.isEmpty ? <li className="list-tip">{lang.template('你关注的人还没有直播')}</li> : null }
            </div>
        );
    }

};

export default List;



// WEBPACK FOOTER //
// ./js/header/follow/list-pannel.js